/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Angel Pacheco

 Description: Alternative combined parser to address changes in navigation data contract
*/
import getFatNavItems from './get-fat-nav-items';
import getProfileBarItems from './get-profile-bar-items';
import getPlatformName from '../../get-platform-name';
import globals from '../../../../../globals/globals';
import getContainersAsMap from './get-containers-as-map';
import getSectionsAsMap from './get-sections-as-map';
import getFooterNavItems from './get-footer-nav-items';
var CONTAINER_NAMES = {
  HEADER: 'HEADER',
  FOOTER: 'FOOTER'
};
var HEADER_IDS = {
  FATNAV: 'FATNAV',
  PROFILE_MENU: 'WELCOME_MESSAGE',
  MASTHEAD_BAR: 'S_MASTHEAD_NAV'
};
export default (function (containers) {
  if (!containers || !containers.length) {
    return {};
  }

  var _globals = globals(),
      customerType = _globals.customerType;

  var _ref = window.utag_data || {},
      custLob = _ref.cust_lob;

  var platformName = getPlatformName({
    customerBranding: customerType,
    business: custLob === 'BIZ'
  });
  var containersMap = getContainersAsMap(containers);
  var headerContainer = containersMap[CONTAINER_NAMES.HEADER];
  var headerSections = getSectionsAsMap(headerContainer && headerContainer.sections);
  var profileBarItems = getProfileBarItems([headerSections[HEADER_IDS.MASTHEAD_BAR], headerSections[HEADER_IDS.PROFILE_MENU]]);
  var navigationBarItems = getFatNavItems(headerSections[HEADER_IDS.FATNAV]);

  var _getFooterNavItems = getFooterNavItems(containersMap[CONTAINER_NAMES.FOOTER]),
      leftLinks = _getFooterNavItems.leftLinks,
      rightLinks = _getFooterNavItems.rightLinks;

  return {
    mastheadNavigationConfig: {
      navigationBarItems: navigationBarItems,
      profileBarItems: profileBarItems
    },
    footerNavigationConfig: {
      leftLinks: leftLinks,
      rightLinks: rightLinks,
      platformName: platformName
    }
  };
});